// extracted by mini-css-extract-plugin
module.exports = {"main":"Login_main-U-e4t","tableWrap":"Login_tableWrap-1JirX"};